import { WorkspaceType } from '@wix/ambassador-os-v1-workspace/types';

export const isDiyWorkspace = (workspace: WorkspaceType | undefined) =>
  workspace === WorkspaceType.DIY;

export const isUnknownWorkspace = (workspace: WorkspaceType | undefined) =>
  workspace === WorkspaceType.UNKNOWN_TYPE;
